const decodeEntity=(value:string)=>value
  .replace(/&#(\d+);/g,(_,code)=>String.fromCodePoint(Number(code)))
  .replace(/&#x([0-9a-f]+);/gi,(_,code)=>String.fromCodePoint(Number.parseInt(code,16)))
  .replace(/&amp;/gi,'&')
  .replace(/&quot;/gi,'"')
  .replace(/&#39;|&apos;/gi,"'")
  .replace(/&lt;/gi,'<')
  .replace(/&gt;/gi,'>')

/** Return only the canonical owner/repository portion used as a GitHub title.
 * Feed decorations, Markdown, HTML and surrounding punctuation are discarded. */
export function normalizeGitHubRepositoryName(value:string){
  const cleaned=decodeEntity(value.normalize('NFKC'))
    .replace(/<[^>]*>/g,' ')
    .replace(/!\[[^\]]*\]\([^)]*\)/g,' ')
    .replace(/\[([^\]]+)\]\([^)]*\)/g,'$1')
    .replace(/[`*~#]+/g,' ')
    .replace(/\s*\/\s*/g,'/')
    .replace(/\s+/g,' ')
    .trim()
  const canonical=cleaned.match(/[A-Za-z0-9_.-]+\/[A-Za-z0-9_.-]+/u)?.[0]
  return canonical??cleaned.replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}._-]+$/gu,'').trim()
}

/** Offer manual translation only for substantial summaries whose readable
 * content is overwhelmingly Latin-script text. */
export function isPredominantlyEnglishSummary(value:string){
  const normalized=decodeEntity(value).replace(/https?:\/\/\S+/gi,' ').replace(/\s+/g,' ').trim()
  const latin=(normalized.match(/[A-Za-z]/g)??[]).length
  const chinese=(normalized.match(/[\u3400-\u9fff]/g)??[]).length
  return normalized.length>=120&&latin>=80&&latin>chinese*3
}
